import React, { Component , Fragment } from "react";

import Header from '../components/Header';
import Headermob from '../components/Headermob';
import Upperheader from '../components/Upperheader';
import Lowerheader from '../components/Lowerheader';
import Footer from '../components/Footer';
import Dashnav from '../components/Dashnav';
import Dashmenu from '../components/Dashmenu';




class Payment extends Component {
    render() {
        return (
            <Fragment>
                <Headermob />
                <Upperheader />
                <Header />
                <Lowerheader />
                <Dashnav title="Payment" />

                <div className="main-div pb-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <Dashmenu />
                            </div>
                            <div className="col-lg-8 pb-5 pt-4 ps-4">
                                <div className="row">
                                
                                    <div className="col-lg-6">
                                        <div className="card bg-white rounded-6 border-0 shadow-xss p-0">
                                            <div className="card-body d-flex justify-content-between align-items-end p-4">
                                                <div>
                                                    <h4 className="text-grey-600 mb-0 d-flex font-xsss align-items-center justify-content-between mt-0 fw-600">
                                                        <img src="assets/images/b-10.png" alt="chip" className="float-left me-4" />
                                                        4321 4432 6565 **** 
                                                    </h4>
                                                </div>
                                                <div className="round float-right mb-2">
                                                    <input id="radio-17" className="radio-custom" name="radio-group" type="radio" checked />
                                                    <label for="radio-17" className="radio-custom-label m-0"></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card bg-white rounded-6 border-0 shadow-xss mt-3 p-0">
                                            <div className="card-body d-flex justify-content-between align-items-end p-4">
                                                <div>
                                                    <h4 className="text-grey-600 mb-0 d-flex font-xsss align-items-center justify-content-between mt-0 fw-600">
                                                        <img src="assets/images/b-9.png" alt="chip" className="float-left me-4" />
                                                        ***port@gmail.com
                                                    </h4>
                                                </div>
                                                <div className="round float-right mb-2">
                                                    <input id="radio-2" className="radio-custom" name="radio-group" type="radio" />
                                                    <label for="radio-2" className="radio-custom-label m-0"></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card bg-white rounded-6 border-0 shadow-xss mt-3 p-0">
                                            <div className="card-body d-flex justify-content-between align-items-end p-4">
                                                <div>
                                                    <h4 className="text-grey-600 mb-0 d-flex font-xsss align-items-center justify-content-between mt-0 fw-600">
                                                        <img src="assets/images/b-12.png" alt="chip" className="float-left me-4" />
                                                        4321 4432 6565 **** 
                                                    </h4>
                                                </div>
                                                <div className="round float-right mb-2">
                                                    <input id="radio-41" className="radio-custom" name="radio-group" type="radio" />
                                                    <label for="radio-41" className="radio-custom-label m-0"></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card bg-white rounded-6 border-0 shadow-xss mt-3 p-0 xs-mb-3">
                                            <div className="card-body d-flex justify-content-between align-items-end p-4">
                                                <div>
                                                    <h4 className="text-grey-600 mb-0 d-flex font-xsss align-items-center justify-content-between mt-0 fw-600">
                                                        <img src="assets/images/b-11.png" alt="chip" className="float-left me-4" />
                                                        **herry@payoner.com 
                                                    </h4>
                                                </div>
                                                <div className="round float-right mb-2">
                                                    <input id="radio-42" className="radio-custom" name="radio-group" type="radio" />
                                                    <label for="radio-42" className="radio-custom-label m-0"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-lg-6">
                                        <div class="rounded-10 bg-greylight bg-dark-black h-100 p-4">
                                            <div class="col-lg-12">
                                                <div class="item ms-auto me-auto mt-0 w-100 h-150 bg-white rounded-10 text-left shadow-lg ps-3 pt-2 align-items-end flex-column d-flex">
                                                    <div class="card border-0 bg-transparent-card shadow-none p-0 text-left w-100">
                                                        <div class="row">
                                                            <div class="col-6 ps-2">
                                                                <img src="assets/images/b-17.png" alt="icon" class="w-60 float-left d-inline-block" />
                                                            </div>
                                                            <div class="col-6 text-right pe-4">
                                                                <img src="assets/images/chip.png" alt="icon" class="w-30 float-end d-inline-block mt-2 me-2" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card border-0 bg-transparent-card shadow-none p-0 text-left w-100 mt-auto">
                                                        <h4 class="text-grey-900 font-xss fw-700 mont-font text-dark-color ls-6">****  ****  ****  2234 <span class="d-block fw-500 text-grey-500 font-xssss mt-0 mb-3 text-dark-color ls-0">Credit Card</span></h4>
                                                    </div>
                                                </div>
                                            </div> 
                                            <div class="card bg-transparent p-0 mt-4 mb-0 border-0 shadow-none">
                                                <h4 class="font-xsssss fw-700 ls-3 mb-4">ADD NEW CARD</h4>
                                                <div class="form-group mb-3">
                                                    <input type="text" class="form-control font-xssss fw-600 bg-white border-0" placeholder="Card Number" />
                                                </div>
                                                <div class="form-group mb-3">
                                                    <input type="text" class="form-control font-xssss fw-600 bg-white border-0" placeholder="Card Holder Name" />
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-6 pe-2">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control font-xssss fw-600 bg-white border-0" placeholder="Month" />
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6 ps-2">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control font-xssss fw-600 bg-white border-0" placeholder="Year" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-check mt-2">
                                                    <input class="form-check-input font-xs" type="checkbox" value="Drinks" id="flexCheckStock" />
                                                    <label class="form-check-label font-xssss fw-600" for="flexCheckStock">Save as default</label>
                                                </div>
                                                <a href="/payment" class="w-100 bg-black-08 text-white font-xsssss p-3 ls-3 fw-700 rounded-6 text-center btn mt-2">SAVE</a>
                                                
                                            </div>       
                                        </div>
                                    </div>
                                
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </Fragment>            
        );
    }
}

export default Payment;